import styled from 'styled-components';

export const FilterPillContainer = styled.div`
  display: flex;
  width: fit-content;
  padding: 5px 5px 5px 10px;
  height: 28px;
  border-radius: 14px;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.themeColor};

  @media ${(props) => props.theme.device.tabletL} {
    white-space: nowrap;
  }
`;

export const Label = styled.div`
  font-size: 14px;
  margin-right: 10px;
  color: ${({ theme }) => theme.colors.white};
`;

export const Remove = styled.div`
  font-size: 14px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};
`;
